import {
    GET_CYLINDER_INWARD_LIST_SUCCESS,GET_CYLINDER_INWARD_LIST_FAILURE,GET_CYLINDER_INWARD_LIST_PROGRESS,
    ADD_CYLINDER_INWARD_SUCCESS,ADD_CYLINDER_INWARD_FAILURE,ADD_CYLINDER_INWARD_PROGRESS,
    EDIT_DELETE_CYLINDER_INWARD_SUCCESS,EDIT_DELETE_CYLINDER_INWARD_FAILURE,EDIT_DELETE_CYLINDER_INWARD_PROGRESS,


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    cylinder_inward: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null,
}

const cylinder_inward_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CYLINDER_INWARD_LIST_SUCCESS:
            return { ...state, cylinder_inward: action.cylinder_inward, loading: false };
        case GET_CYLINDER_INWARD_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CYLINDER_INWARD_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CYLINDER_INWARD_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_INWARD_SUCCESS:
            return { ...state, cylinder_inward: [...state.cylinder_inward, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_INWARD_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CYLINDER_INWARD_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CYLINDER_INWARD_SUCCESS:
            return {
                ...state,
                cylinder_inward: state.cylinder_inward.map((cylinder_inward) =>
                    cylinder_inward.id === action.payload.id ? action.payload : cylinder_inward
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CYLINDER_INWARD_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default cylinder_inward_reducer;